import { computed, ref } from 'vue'
const confirmModalData = ref(null)
const isOpen = computed(() => !!confirmModalData.value)

export function useConfirm() {
  const showConfirm = ({
    title = 'Unsaved changes',
    message = "Your changes haven't been saved and will be lost.",
    icon = 'alert-triangle',
    confirmText = 'Discard',
    cancelText = 'Go back',
    continueText = null,
    confirmColor = 'brand',
    cancelColor = 'brand-light',
    continueColor = 'primary',
    onConfirm = () => {},
    onCancel = () => {},
    onContinue = null,
  } = {}) => {
    confirmModalData.value = {
      title,
      message,
      icon,
      confirmText,
      cancelText,
      continueText,
      confirmColor,
      cancelColor,
      continueColor,
      onConfirm,
      onCancel,
      onContinue,
    }
  }

  const closeConfirm = () => {
    confirmModalData.value = null
  }

  return {
    isOpen,
    confirmModalData,
    showConfirm,
    closeConfirm,
  }
}
